import React, { useEffect, useState } from "react";
import { Box, Button, CheckBox, CheckBoxGroup, Grid, Heading, Layer, RadioButtonGroup, Spinner, Text, TextInput, Image } from "grommet";
import { Map, Favorite, Favorite as FavoriteOutline, Filter, FormSearch, Home, User } from "grommet-icons";
import axios from "axios";
import { format } from "date-fns";
import { take } from "lodash";
import { useNavigate } from "react-router-dom";
import { useUser } from "../utils/AccountStore";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export interface Schedule {
    id: string;
    title: string;
    time: string;
    location: string;
    description: string;
    speaker: string;
    allDay: boolean;
}

interface Attendee {
    id: string;
    mySchedule: string[];
}

const SchedulePage = () => {
    const [schedules, setSchedules] = useState<Schedule[]>([]);
    const [filteredSchedules, setFilteredSchedules] = useState<Schedule[]>([]);
    const { user, getUser } = useUser();
    const [filter, setFilter] = useState("");
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [locations, setLocations] = useState<string[]>([]);
    const [days, setDays] = useState<string[]>([]);
    const [locationFilter, setLocationFilter] = useState<string[]>([]);
    const [favouritesFilter, setFavouritesFilter] = useState<boolean>(false);
    const [dayFilter, setDayFilter] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(100);

    useEffect(() => {
        const fetchSchedules = async () => {
            const response = await axios.get(`${Server}/api/schedules`);
            return response.data;
        };

        const init = async () => {
            try {
                const data: Schedule[] = await fetchSchedules();
                const sorted = data.sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());
                setSchedules(sorted);
                setDays(sorted.map((s) => format(new Date(s.time), "EEEE")).filter((v, i, self) => self.indexOf(v) === i));
                setLocations(sorted.map((s) => s.location).filter((v, i, self) => self.indexOf(v) === i));
            } catch (err) {
                alert("Error loading schedules");
            }
            setLoading(false);
        };

        init();
    }, []);

    useEffect(() => {
        const result = schedules.filter((s) => {
            const matchesSearch = s.title.toLowerCase().includes(filter.toLowerCase());
            const matchesDay = dayFilter ? format(new Date(s.time), "EEEE") === dayFilter : true;
            const matchesLocation = locationFilter.length ? locationFilter.includes(s.location) : true;
            const matchesFavourites = favouritesFilter ? user.mySchedule.includes(s.id) : true;

            return matchesSearch && matchesDay && matchesLocation && matchesFavourites;
        });

        setFilteredSchedules(result);
    }, [schedules, filter, dayFilter, locationFilter, favouritesFilter, user]);

    const toggleFavorite = (id: string) => {
        const updated = user.mySchedule.includes(id) ? user.mySchedule.filter((sid) => sid !== id) : [...user.mySchedule, id];

        axios
            .post(`${Server}/api/attendees/toggleMySchedule`, {
                userID: user.id,
                scheduleID: id,
            })
            .then(() => {
                getUser();
            });
    };

    const clearFilters = () => {
        setFilter("");
        setDayFilter("");
        setLocationFilter([]);
        setFavouritesFilter(false);
        setShowFilterModal(false);
    };

    const navigate = useNavigate();

    return (
        <Box pad="medium" gap="small" fill>
            <Grid columns={["1fr", "auto", "1fr"]} width="100%" align="center">
                <Home color="brand" onClick={() => navigate("/home")} />
                <Heading level="2" color="brand">
                    {/* Agenda */}
                </Heading>
                <Box direction="row" gap="small" align="center" justify="end">
                    {/* <Button icon={<Filter />} onClick={() => setShowFilterModal(true)} /> */}
                </Box>
            </Grid>

            {/* <TextInput icon={<FormSearch />} placeholder="Search" value={filter} onChange={(e) => setFilter(e.target.value)} /> */}

            <Box align="center" justify="center" pad="none" overflow="auto" round="medium" fill style={{ borderRadius: "10px" }}>
                <TransformWrapper minScale={1} maxScale={5} wheel={{ step: 0.1 }} doubleClick={{ disabled: false, step: 1 }} pinch={{ step: 5 }} centerZoomedOut={true} limitToBounds>
                    <TransformComponent>
                        <Image
                            src={"https://scadsyscloudblobs.blob.core.windows.net/expo-file-blobs/tandem.web--cb01789d-ab5b-4ccf-aaaf-46cd5a1efd81-agenda.jpg"}
                            alt="FloorPlan"
                            fit="contain"
                            style={{ maxWidth: "100%", maxHeight: "90vh", borderRadius: "10px" }}
                        />
                    </TransformComponent>
                </TransformWrapper>
            </Box>

            {/* {loading && <Spinner size="medium" />}

            {!loading && (
                <Box overflow="auto">
                    {take(filteredSchedules, pageSize).map((schedule) => (
                        <Box key={schedule.id} border={{ side: "bottom", color: "light-4" }} pad={{ vertical: "small" }} gap="xsmall">
                            <Box
                                direction="row"
                                justify="between"
                                onClick={() => {
                                    navigate(`/scheduleDetails/${schedule.id}`)
                                }}
                            >
                                <Box>
                                    <Text weight="bold">{schedule.title}</Text>
                                    <Text size="small">{format(new Date(schedule.time), schedule.allDay ? "EEEE" : "EEEE HH:mm")}</Text>
                                    {schedule.description && (
                                        <Box direction="row" gap="xsmall" align="center">
                                            <Text size="small">{schedule.description}</Text>
                                        </Box>
                                    )}
                                    {schedule.location && (
                                        <Box direction="row" gap="xsmall" align="center">
                                            <Map size="small" />
                                            <Text size="small">{schedule.location}</Text>
                                        </Box>
                                    )}
                                    {schedule.speaker && (
                                        <Box direction="row" gap="xsmall" align="center">
                                            <User size="small" />
                                            <Text size="small">{schedule.speaker}</Text>
                                        </Box>
                                    )}
                                </Box>
                                <Button plain onClick={() => toggleFavorite(schedule.id)} icon={user.mySchedule?.includes(schedule.id) ? <Favorite color="red" /> : <FavoriteOutline />} />
                            </Box>
                        </Box>
                    ))}
                    {filteredSchedules.length > pageSize && (
                        <Box align="center" margin={{ top: "medium" }}>
                            <Button label="Load More" onClick={() => setPageSize((prev) => prev + 10)} />
                        </Box>
                    )}
                </Box> 
            )} */}

            {/* {showFilterModal && (
                <Layer onEsc={() => setShowFilterModal(false)} onClickOutside={() => setShowFilterModal(false)} background={"#b4021f"}>
                    <Box pad="medium" width="medium" gap="medium">
                        <Box direction="row" justify="between" align="center">
                            <Heading level={3} margin="none">
                                Filters
                            </Heading>
                            <Button label="Clear" onClick={clearFilters} />
                        </Box>

                        <CheckBox label="Show only favourites" checked={favouritesFilter} onChange={(e) => setFavouritesFilter(e.target.checked)} />

                        <Box>
                            <Text>Filter by Day</Text>
                            <RadioButtonGroup name="days" options={days} value={dayFilter} onChange={(event) => setDayFilter(event.target.value)} />
                        </Box>

                        <Box>
                            <Text>Filter by Location</Text>
                            <CheckBoxGroup options={locations} value={locationFilter} onChange={({ value }) => setLocationFilter(value)} />
                        </Box>

                        <Button label="Close" color={"white"} onClick={() => setShowFilterModal(false)} />
                    </Box>
                </Layer>
            )} */}
        </Box>
    );
};

export default SchedulePage;
